// extracted by mini-css-extract-plugin
export default {"locked":"styles_locked__3lBWc"};